/** @format */
import styled from "styled-components";
import { useState } from "react";

import Expenses from "./components/expenses/Expenses";
import NewExpense from "./components/NewExpense";
import installExpensesData from "./data/data";

const App = () => {
	const [expenses, setExpenses] = useState(installExpensesData);

	const addExpenseHandler = (expense) => {
		setExpenses((previousExpense) => {
			return [expense, ...previousExpense];
		});

		/*
		// Second fix(working)
		const newExpense = [expense, ...expenses];
		setExpenses(newExpense);

		*/
	};

	return (
		<AppWrapper>
			<NewExpense onAddExpense={addExpenseHandler} />
			<Expenses items={expenses} />
		</AppWrapper>
	);
};

export default App;

const AppWrapper = styled.div`
	width: 100%;
`;

// https://expense-tracker-82c4a.web.app
